import { Suspense } from 'react';
import { BrowserRouter, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store';
import ThemeProvider from './theme';
import LoadingSpinner from './common/Components/LoadingSpinner/LoadingSpinner';
import Icons from './common/Icons/Icons';
import PluginsLoader from './plugins/PluginsLoader';
import Overlay from './common/Overlay/Overlay';
import routes from './routes';
import NotistackProvider from 'ui/components/Notistack';
import GlobalStyles from '@mui/material/GlobalStyles';
import { LicenseInfo } from '@mui/x-license-pro';
import { IframeMessageListenerProvider } from 'contexts/IframeMessageListener';
import { isRenderedAsIframeInNewUI } from 'config';
import { useIframeDisableClicks } from 'pages/useIframeDisableClicks';

LicenseInfo.setLicenseKey(
  'f70dd425847cf5cd2a4640ca028b596aTz01Mjk4NyxFPTE2OTgxNDIxMjI0MTUsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
);

function App() {
  useIframeDisableClicks();

  const RoutesComponent = isRenderedAsIframeInNewUI
    ? () => (
        <IframeMessageListenerProvider>
          <Routes>{routes}</Routes>
        </IframeMessageListenerProvider>
      )
    : () => <Routes>{routes}</Routes>;

  return (
    <Provider store={store}>
      <ThemeProvider>
        <GlobalStyles
          styles={theme => ({
            html: {
              scrollBehavior: 'smooth'
            },
            ':visited': {
              color: theme.palette.text.secondary
            },
            '*::-webkit-scrollbar': {
              backgroundColor: 'transparent',
              width: '4px',
              height: '4px',
              borderRadius: 8
            },
            '*::-webkit-scrollbar-thumb': {
              borderRadius: 8,
              backgroundColor: theme.palette.background.scroll,
              '&:focus, &:active, &:hover': {
                backgroundColor: theme.palette.background.scrollActive
              }
            },
            '*::-webkit-scrollbar-track': {
              backgroundColor: 'transparent'
            },
            '*::-webkit-scrollbar-button': {
              backgroundColor: 'transparent',
              display: 'none'
            },
            '*::-webkit-scrollbar-corner': {
              backgroundColor: 'transparent'
            }
          })}
        />
        <NotistackProvider>
          <Suspense fallback={<LoadingSpinner blockUI />}>
            <BrowserRouter>
              <RoutesComponent />
            </BrowserRouter>
            <Overlay />
          </Suspense>
          <Icons />
          <PluginsLoader />
        </NotistackProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
